var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#A28CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9942 14.3224C15.5833 19.0038 11.2705 25.7805 9.29099 28.6943C8.91991 29.2405 9.12206 29.4113 9.63095 28.9905C14.5578 24.9164 20.4269 22.0287 24.3086 22.5927C24.4575 22.6143 24.4924 22.8057 24.3653 22.8862C22.7073 23.9362 19.95 25.9613 19.2758 27.6643C18.9668 28.4447 18.7976 29.914 18.782 30.9656C18.7761 31.3623 19.1055 31.6668 19.5023 31.6668H30.9228C31.3278 31.6668 31.6641 31.3492 31.6669 30.9442C31.736 20.7467 21.6115 11.7997 16.4214 8.541C15.6285 7.94803 14.233 8.27416 14.9942 14.3224Z",
    fill: "#0A0502"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/hold.e0f52625976a470680a55d6a0effa2b5.svg";
export { ForwardRef as ReactComponent };